import React, { useEffect, useState } from 'react';
import { Routes, Route } from "react-router-dom";



import Dashboard from "../Admin/index";
import Logout from "../Admin/logout";
import CustomerManagement from "../Admin/customerManagement";
import Package from '../Admin/package';
import PackageAdd from '../Admin/packageAdd';
import Reports from '../Admin/reports';
import Customerlist from "../Admin/CustomerList";



import P404 from "../Admin/P404";
import Sidebar from "../Admin/inc/Sidebar";
import Header from "../Admin/inc/Header";
import Footer from "../Admin/inc/Footer";
import bgImage from '../assets/e_learning_bg3.jpg';





const AdminRouting = () => {

    const [isMenuCollapsed, setIsMenuCollapsed] = useState(false);

    const handleMenuToggle = () => {
        setIsMenuCollapsed(!isMenuCollapsed);

    };

    //const navigate  = useNavigate();
    //const user_typ =  localStorage.getItem('user_typ');

    useEffect(() => {
        // if(user_typ=='student'){
        // }else{
        //   navigate("/");  
        // }
    }, []);




    return (
        <>
            <div className={`flapt-page-wrapper ${isMenuCollapsed ? 'menu-collasped-active' : ''}`}
                style={{
                    position: 'relative',
                    minHeight: '100vh',
                }}
            >
                {/* <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: `url(${bgImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    opacity: 0.2,
                    zIndex: -1,
                }} /> */}
                <div style={{ position: 'relative', zIndex: 1 }}>
                    <Sidebar isMenuCollapsed={isMenuCollapsed} />
                    <div class="flapt-page-content">
                        <Header onButtonClick={handleMenuToggle} />



                        <div class="main-panel">
                            <div class="content-wrapper">
                                <Routes>
                                    <Route exact path="/" element={<Dashboard />} />
                                    <Route exact path="/dashboard" element={<Dashboard />} />
                                    <Route exact path="/logout" element={<Logout />} />
                                    <Route exact path="/cust_management" element={<CustomerManagement />} />
                                    <Route exact path="/package" element={<Package />} />
                                    <Route exact path="/package/add" element={<PackageAdd />} />
                                    <Route exact path="/package/edit/:id" element={<PackageAdd />} />
                                    <Route exact path="/reports" element={<Reports/>} />
                                    <Route exact path="/customerlist" element={<Customerlist />} />






                                    <Route exact path="/*" element={<P404 />} />
                                </Routes>

                              
                            </div>
                            <Footer />
                        </div>



                    </div>
                </div>
            </div>



























        </>
    );
};

export default AdminRouting;
